import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export type BackOrigin = { backTo: string };

const LIST_URL_KEY = "blogic:listUrl:";

export function backOrigin(path: string): BackOrigin {
  return { backTo: path };
}

export function useBackOrigin(): BackOrigin {
  const { pathname, search } = useLocation();
  return backOrigin(`${pathname}${search}`);
}

function isAppPath(path: unknown): path is string {
  return typeof path === "string" && path.startsWith("/") && !path.startsWith("//");
}

function readListUrl(listPath: string): string | null {
  try {
    const saved = sessionStorage.getItem(LIST_URL_KEY + listPath);
    return isAppPath(saved) && (saved === listPath || saved.startsWith(`${listPath}?`)) ? saved : null;
  } catch {
    return null;
  }
}

function writeListUrl(listPath: string, url: string): boolean {
  try {
    sessionStorage.setItem(LIST_URL_KEY + listPath, url);
    return true;
  } catch {
    return false;
  }
}

export function useRememberListUrl(enabled = true) {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (enabled) writeListUrl(pathname, `${pathname}${search}`);
  }, [enabled, pathname, search]);
}

export function useBackTo(fallback: string): string {
  const { state } = useLocation();
  const origin = (state as Partial<BackOrigin> | null)?.backTo;
  if (isAppPath(origin)) return origin;
  return readListUrl(fallback) ?? fallback;
}
